export function getLoyaltyProgramsToPrefill({
  fields,
  currentFieldName,
  userLoyaltyPrograms,
  availableLoyaltyPrograms,
}) {
  if (!availableLoyaltyPrograms) {
    const fieldWithFFOptionsName = currentFieldName.includes(
      "frequent_flyer_number"
    )
      ? currentFieldName.split("frequent_flyer_number").join("frequent_flyer")
      : currentFieldName;

    const availableLoyaltyProgramsFromOptions =
      fields[fieldWithFFOptionsName]?.options || [];

    if (availableLoyaltyProgramsFromOptions?.type === "codebook") {
      return {
        loyaltyProgramId: "",
        loyaltyProgramMembershipId: "",
      };
    }

    const loyaltyProgramToPrefill = userLoyaltyPrograms.find(
      (userLoyaltyProgram) =>
        availableLoyaltyProgramsFromOptions.some(
          (availableLoyaltyProgram) =>
            availableLoyaltyProgram.value === userLoyaltyProgram.Id
        )
    );

    return {
      loyaltyProgramId: loyaltyProgramToPrefill?.Id || "",
      loyaltyProgramMembershipId: loyaltyProgramToPrefill?.MembershipId || "",
    };
  }

  const loyaltyProgramToPrefill = userLoyaltyPrograms.find(
    (userLoyaltyProgram) =>
      availableLoyaltyPrograms.some(
        (availableLoyaltyProgram) =>
          availableLoyaltyProgram.Code === userLoyaltyProgram.Id
      )
  );

  return {
    loyaltyProgramId: loyaltyProgramToPrefill?.Id || "",
    loyaltyProgramMembershipId: loyaltyProgramToPrefill?.MembershipId || "",
  };
}
